module.exports = __webpack_public_path__ + "static/img/banner2.0280d7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/仪器设备/banner2.jpg
// module id = UJz6
// module chunks = 16